module.exports = __webpack_public_path__ + "img/room_bg.89bc7ffa.png";